import { useTX } from '@transifex/react';
import { useTranslationsIsReady } from './use-tx-translations-loader';

type TranslationsLoader = {
  isReady: boolean;
  tx: ReturnType<typeof useTX>;
};

export const useTranslationsLoader = (language: string): TranslationsLoader => {
  const tx = useTX();
  const isReady = useTranslationsIsReady(tx, language);

  return {
    isReady,
    tx,
  };
};
